import master from '@MasterData/consumption_taxes.json';

type PricedItem = Readonly<{
    amount: number;
    include_tax: boolean;
    tax_percent: number;
}>;

export class ConsumptionTax implements PricedItem {
    static get defaultPercent(): number {
        return master.find((t) => t.default)!.percent;
    }

    static get existingPercents(): number[] {
        return master.filter((t) => t.existing).map((t) => t.percent);
    }

    readonly amount: number;
    readonly include_tax: boolean;
    readonly tax_percent: number;
    constructor(item: PricedItem) {
        this.amount = item.amount;
        this.include_tax = item.include_tax;
        this.tax_percent = item.tax_percent;
    }

    get tax() {
        const numerator = this.tax_percent * this.amount;
        const denominator = this.include_tax ? 100 + this.tax_percent : 100;
        return Math.floor(numerator / denominator);
    }

    get amountIncludingTax() {
        if (this.include_tax) return this.amount;
        return this.amount + this.tax;
    }

    get amountExcludingTax() {
        if (!this.include_tax) return this.amount;
        return this.amount - this.tax;
    }
}
